import Component from '../core/Component'
import ScrollService, {disableScroll, enableScroll, scrollToElement} from '../services/Scroll'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

const STATES = {
    ACTIVE: 'is-active',
    EXPAND: 'is-expanded',
    HIDDEN: 'is-hidden',
    NOTRANSITION: 'no-transition'
}

export default class Header extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            hamburger: null,
            navigation: null
        }

        this.state = {
            status: false,
            linkList: [],
            windowWidth: null,
            touchStartPosition: null,
            touchEndPosition: null,
            isTouchDevice: null,
            scrollYPosition: null,
            navigationRect: null
        }

        this.backgroundOverlay
        this.body
        this.firstLoad = true
    }

    prepare() {
        EventBus.on(EVENTS.SWUP_WILL_REPLACE_CONTENT, this.handleClick)

        this.state.linkList = this.ref.navigation.querySelectorAll('a')
        this.backgroundOverlay = document.querySelector('.BackgroundOverlay')
        this.body = document.querySelector('body')
        this.ref.hamburger.addEventListener('click', this.handleNavState)
        this.ref.navigation.addEventListener('touchstart', this.handleTouch)
        this.ref.navigation.addEventListener('touchend', this.handleTouch)
        this.ref.navigation.addEventListener('touchmove', this.handleTouch)
        this.ref.navigation.addEventListener('click', this.handleMobileClose)
        document.addEventListener('click', this.handleClickOutside)
        ScrollService.on('scroll', this.handleScroll)
        ScrollService.on('resize', this.handleResize)

        this.state.isTouchDevice = this.isTouchDevice()

        document.addEventListener('keydown', (e) => {
            if(e.keyCode == 27){
                this.closeNavigation()
            }
        });

        this.ref.navigation.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', this.handleClick)
        })
    }

    destroy() {
        EventBus.off(EVENTS.SWUP_WILL_REPLACE_CONTENT, this.handleClick)

        this.ref.hamburger.removeEventListener('click', this.handleNavState)
        this.ref.navigation.removeEventListener('touchstart', this.handleTouch)
        this.ref.navigation.removeEventListener('touchend', this.handleTouch)
        this.ref.navigation.removeEventListener('touchmove', this.handleTouch)
        document.removeEventListener('click', this.handleClickOutside)
        ScrollService.off('scroll', this.handleScroll)
        ScrollService.off('resize', this.handleResize)
    }

    handleClick = () => {

        if(window.location.href === event.target.href) {
            return
        }
        this.closeNavigation()
    }

    handleScroll = ({ y }) => {
        this.render(y)
        this.state.scrollYPosition = y
    }

    handleResize = () => {
        this.state.windowWidth = window.innerWidth
        if(this.state.windowWidth > 767 && this.element.classList.contains('is-bottom-pinned')) {
            this.element.classList.remove('is-bottom-pinned')
        }

        if(this.state.windowWidth > 767 && !this.state.isTouchDevice) {
            this.element.style.top = `${this.state.scrollYPosition + 35}px`
            this.element.style.position = 'fixed'
            this.element.style.top = `${35}px`
        } else if (this.state.isTouchDevice) {
            this.element.style.top = `${this.state.scrollYPosition + 20}px`
            this.element.style.top = `${20}px`
        }
    }
    
    render(y) {
        if(this.state.windowWidth > 767 && !this.state.isTouchDevice) {
            this.element.style.position = 'fixed'
            this.element.style.top = `${35}px`
        } else if (this.state.isTouchDevice) {
            this.element.style.top = `${20}px`
        }
    }

    isTouchDevice = () => {
        return (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0));
    }

    handleTouch = (event) => {
        if(!this.element.classList.contains('is-bottom-pinned')) {
            return
        }

        if(event.type === 'touchstart') {
            this.state.touchStartPosition = event.touches[0].clientY
        } else {
            this.state.touchEndPosition = event.changedTouches[0].clientY
        }

        if(event.type === 'touchend') {
            const touchLength = -(this.state.touchStartPosition - this.state.touchEndPosition)
            if(touchLength / 4.2 > 50) {
                this.closeNavigation()
                this.ref.navigation.style.transform = ''
                this.backgroundOverlay.style.opacity = ''
            }
        }

        if(event.type === 'touchmove') {
            let shiftValue = event.targetTouches[0].clientY - this.state.touchStartPosition
            let shifting = 100 / this.state.navigationRect.height * shiftValue
            if(shifting > 0) {
                this.ref.navigation.style.transform = `translateY(${shifting * 0.5}%)`
                this.backgroundOverlay.style.opacity = `${-shifting * 0.00000000000001}`
                clearTimeout(this.touchMoveTimer)
                if(shifting < 50) {
                    this.touchMoveTimer =  setTimeout(() => {
                        this.ref.navigation.style.transform = `translateY(0%)`
                        this.backgroundOverlay.style.opacity = '0.4'
                    }, 200)
                }
            }
        }
    }

    handleMobileClose = (event) => {
        if(!this.element.classList.contains('is-bottom-pinned')) {
            return
        }
        let topOffsetNavigation = this.state.navigationRect.top - this.state.navigationRect.height - event.clientY
        if((-topOffsetNavigation) < 45) {
            this.closeNavigation()
        }
    }

    handleClickOutside = (event) => {
        const withinBoundariesElement = event.composedPath().includes(this.element)

        if (withinBoundariesElement) {
            return
        } else {
            this.closeNavigation()
            if(this.state.status) {
                this.element.classList.add(STATES.HIDDEN)
            }
            this.state.status = false
        }
    }

    handleTabKey = () => {
        this.state.linkList.forEach((link) => {
            if(this.state.status) {
                link.setAttribute('tabindex', '0')
            } else {
                link.setAttribute('tabindex', '-1')
            }
        })
    }

    handleNavState = () => {
        if(this.state.status) {
            this.closeNavigation()
        } else {
            this.openNavigation()
        }
    }

    handleActive = () => {
        this.ref.navigation.querySelectorAll('a').forEach(link => {
            if(window.location.href === link.href) {
                link.classList.add('is-active')
                link.addEventListener('click', (event) => {
                    event.preventDefault()
                    this.closeNavigation()
                    scrollToElement(document.querySelector('#swup'))
                })
            } else {
                link.classList.remove('is-active')
            }
        })
    }

    openNavigation = () => {
        this.element.classList.remove(STATES.NOTRANSITION)
        disableScroll()
        EventBus.emit('showOverlay')
        this.element.classList.add(STATES.ACTIVE, STATES.EXPAND)
        this.element.classList.remove(STATES.HIDDEN)
        this.state.status = true
        this.handleTabKey()
        this.handleActive()
        document.querySelector('.MobileLogo').style.zIndex = 84
        
        this.state.navigationRect = this.ref.navigation.getBoundingClientRect();
    }

    closeNavigation = () => {
        enableScroll()
        EventBus.emit('hideOverlay')
        this.element.classList.remove(STATES.ACTIVE, STATES.EXPAND)
        this.element.classList.add(STATES.HIDDEN)
        this.state.status = false
        this.handleTabKey()
        document.querySelector('.MobileLogo').style.zIndex = 100
    }
}
